<template>
  <div>
    <SpFilterForm :model="formData" @onSearch="onSearch" @onReset="onSearch">
      <SpFilterFormItem>
        <el-input v-model="formData.order_id" placeholder="请输入补购编号" />
      </SpFilterFormItem>
      <SpFilterFormItem>
        <el-input v-model="formData.acm_order_code" placeholder="请输入ACM单号" />
      </SpFilterFormItem>
      <!-- <SpFilterFormItem>
        <el-button  size="medium" class="btn_input" @click="handleGoodsDialogShow">{{ goods_num }} <i
          class="el-icon-circle-plus icon"></i></el-button>
      </SpFilterFormItem> -->
      <SpFilterFormItem>
        <el-input v-model="formData.sn" placeholder="请输入绑定的商品SN" />
      </SpFilterFormItem>
      <!-- <SpFilterFormItem>
        <el-button size="medium" class="btn_input" @click="onDialog">{{ shop_num }} <i class="el-icon-circle-plus icon"></i></el-button>
      </SpFilterFormItem> -->
      <SpFilterFormItem>
        <el-select
              v-model="formData.bind_status"
              placeholder="请选择绑定状态"
              clearable
            >
              <el-option
                v-for="item in bindStatusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
      </SpFilterFormItem>
      <SpFilterFormItem>
        <el-select
              v-model="formData.source_type"
              placeholder="请选择购买额类型"
              clearable
            >
              <el-option
                v-for="item in purchaseTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
      </SpFilterFormItem>
      <SpFilterFormItem>
        <el-date-picker v-model="pay_time" type="daterange" value-format="yyyy/MM/dd" placeholder="选择日期范围" @change="dateChange"></el-date-picker>
      </SpFilterFormItem>

    </SpFilterForm>
    <SpFinder
      ref="finder"
      row-key="item_id"
      :split-count="10"
      :url="table_url"
      :setting="setting"
      fixed-row-action
      no-selection
      row-actions-fixed-align="right"
      :hooks="{
        beforeSearch: beforeSearch,
      }"
    />
    <DistributorSelect :store-visible="distributorVisible" :is-valid="true" :relDataIds="distributor_info"
      :get-status="false" @chooseStore="chooseDistributorAction" @closeStoreDialog="closeDialogAction"
      returnType="selectRow" />
    <GoodsSelector :single="false" :items-visible="itemVisible" :get-status="setItemStatus" :rel-items-ids="relItems"
      item-type="normal" @chooseStore="handleGoodsSubmit" @closeStoreDialog="handleGoodsDialogHide"></GoodsSelector>
  </div>
</template>
<script>
import DistributorSelect from '@/components/function/distributorSelect'
import GoodsSelector from '@/components/goodsSelect/index'
import { useDialog } from '@shopex/finder'
import { tableSetting } from './config'
import { List, handleExport } from './api'

export default {
  components: {
    DistributorSelect,
    GoodsSelector
  },
  data () {
    return {
      pay_time:'',
      table_url: List,
      relItems: [],
      formData: {
        order_id: '',
        acm_order_code: '',
        shop_code: '',
        item_bn: '',
        goods_id: '',
        sn: '',
        time_start_begin: '',
        time_start_end: '',
        bind_status: '',
        source_type: ''
      },
      bindStatusList: [
        {label: '注册中', value: 'NOBIND,BINDING'},
        {label: '已注册', value: 'BIND_SUCCESS'},
        {label: '注册失败', value: 'BIND_FAIL'},
        {label: '取消中', value: 'NOBINDIND'},
        {label: '已取消', value: 'UNBIND'},
        {label: '取消失败', value: 'UNBIND_FAIL'},
      ],
      purchaseTypeList: [
        {label: '补购', value: 'BUY_IN'},
        {label: '续订', value: 'RENEW'},
      ],
      shop_num: '归属店铺',
      distributorVisible: false,
      distributor_info: [],
      goods_num: '选择绑定商品',
      itemVisible: false,
      setItemStatus: false,
    }
  },
  computed: {
    setting() {
      return tableSetting(this)
    }
  },
  mounted() {
    this.initDate();
  },
  methods: {
    beforeSearch (params) {
      return {
        ...params,
        ...this.formData
      }
    },
    initDate() {
      let start = new Date(new Date().toLocaleDateString())
      let end = new Date(new Date().toLocaleDateString())
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      end.setTime(end.getTime() + 86399999)

      this.pay_time = [start, end];
      this.formData.time_start_begin = this.time_start_begin = start / 1000;
      this.formData.time_start_end = this.time_start_end = end / 1000;

    },
    dateChange (val) {
     console.log(val);

        console.log(11111);
        if (!val) {
             this.formData.time_start_begin = ''
            this.formData.time_start_end = ''
            return
        }
        if (val.length > 0) {
          this.formData.time_start_begin = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
          this.formData.time_start_end = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
        }
      },
      dateStrToTimeStamp (str) {
        return Date.parse(new Date(str))/1000
      },
    onSearch () {
      this.$refs.finder.refresh(true)
    },
    openExportDialog  () {
      const exportParams = {
        ...this.formData,
        is_export: 1,
      }
      handleExport(exportParams).then(_ => {
        this.$message.success('导出成功，请前往导出列表查看')
      })
    },
    refresh() {
      this.$refs.finder.refresh()
    },
    onDialog() {
      this.distributorVisible = true
    },
    closeDialogAction () {
      this.distributorVisible = false
    },
    chooseDistributorAction(val) {
      this.distributor_info = val
      let arr = []
      val.forEach(i => {
        arr.push(i.shop_code)
      });
      this.formData.shop_code = arr.join(',')
      if (val.length > 0) {
        this.shop_num = `已选择${val.length}门店`
      } else {
        this.shop_num = '归属店铺'
      }
      this.closeDialogAction()
    },
    handleGoodsSubmit(data) {
      let arr = []
      let goodIds = []
      data.forEach(i => {
        arr.push(i.item_bn)
        goodIds.push(i.goods_id)
      });
      this.formData.item_bn = arr.join(',')
      this.formData.goods_id = goodIds.join(',')
      if (data.length > 0) {
        this.goods_num = `已选中${data.length}个商品`
      } else {
        this.goods_num = '选择订单包含商品'
      }
      this.relItems = data
      this.handleGoodsDialogHide()
    },
    // 选择商品弹窗
    handleGoodsDialogShow() {
      this.itemVisible = true
      this.setItemStatus = true
    },
    handleGoodsDialogHide() {
      this.itemVisible = false
    },
  }
}
</script>
<style scoped lang="scss">
::v-deep .sp-finder .cell .sp-finder-actions__wrap {
  justify-content: center !important;
}
</style>
